import React, { useState, useEffect } from 'react';
import { useUser } from '../context/UserContext';
import { useNavigate } from 'react-router-dom';
export default function SelectEtablissement() {
  const {
    user,
    selectedEtablissementId,
    setSelectedEtablissementId,
  } = useUser();

  // 1️⃣ état local avant validation
  const [tempEtab, setTempEtab] = useState(null);

const navigate = useNavigate();
  const handleValidate = () => {
    // ne rien faire si on n'a pas réellement changé
    if (tempEtab && tempEtab !== selectedEtablissementId) {
      
      setSelectedEtablissementId(tempEtab);
       navigate('/home/');
    }
  };

  return (
    <div className="select-etablissement p-4 bg-white rounded shadow">
      <label htmlFor="select-etab" className="block mb-2 font-medium">
        Choisissez un établissement :
      </label>
      <select
        id="select-etab"
        className="border px-2 py-1 w-full mb-4"
        value={tempEtab}
        onChange={(e) => setTempEtab(Number(e.target.value))}
      >
        <option value="" disabled>-- Sélectionnez --</option>
        {user.etablissements.map((etab) => (
          <option key={etab.id} value={etab.id}>
            {etab.nom}
          </option>
        ))}
      </select>
      <button
        className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 disabled:opacity-50"
        onClick={handleValidate}
        disabled={!tempEtab || tempEtab === selectedEtablissementId}
      >
        Valider
      </button>
    </div>
  );
}